import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const EmailContext = createContext();
const FilterContext = createContext()

export const useEmail = () => useContext(EmailContext);
export const useFilter = () => useContext(FilterContext)

const EmailProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState("")
  const [priceRangeName, setPriceRangeName] = useState("All Price")

  const EmailVerify = async () => {
    const Email = localStorage.getItem("user");
    if (Email) {
      await axios.get(
        `${process.env.REACT_APP_API_URL}/api/auth/get/UserMasterDetails/${Email}`)
        .then((response) => {
          const user = response.data;
          setUserData(response.data);
        })
        .catch((error) => {
          console.error("Error in user verification process:", error);
        });
    } else {
      console.log("No token found");
      setUserData(null)
    }
  };

  const handleSearchClick = () => {
    navigate(`/product-list?search=${encodeURIComponent(searchText)}`)
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      navigate(`/product-list?search=${encodeURIComponent(searchText)}`)
    }
  };

  const handleInputChange = (e) => {
    return setSearchText(e); // Directly setting the value from input
  };

  return (
    <EmailContext.Provider value={{
      EmailVerify, userData, setUserData
    }}>
      <FilterContext.Provider value={{
        searchText, setSearchText, handleKeyDown, handleSearchClick, handleInputChange, priceRangeName, setPriceRangeName
      }}>
        {children}
      </FilterContext.Provider>
    </EmailContext.Provider>
  );
};

export default EmailProvider;
